import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ThinnerSMSIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {Link} from "react-router-dom";
import {AdminsSMSAbsentsModal} from "./sms-absents";

export interface absentsInterface {
    id: number,
    name: string,
    tell: string,
    sms: boolean,
    class: string,
    send: boolean,
}

export const AdminsAttendAbsentsScreen = () => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as absentsInterface[]);
    const fetchList = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + "/core/admins/attend/absents",
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: absentsInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                setList(d.list === null ? [] : d.list);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "غایبین | نهال";
        fetchList();
    }, []);
    const [smsModal, setSMSModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'حضورغیاب', url: '/admins/attend'},
                {title: 'غایبین', url: '/admins/attend/absents'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>لیست غایبین</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 10}}>
                                    {/*<button onClick={() => {*/}
                                    {/*    const _class = {...classSelected};*/}
                                    {/*    const now = {...time};*/}
                                    {/*    const from = PersianToGregorian(DateFixToGoLayout(`${now.from?.year}-${now.from?.month}-${now.from?.day}`));*/}
                                    {/*    const to = PersianToGregorian(DateFixToGoLayout(`${now.to?.year}-${now.to?.month}-${now.to?.day}`));*/}
                                    {/*    window.open(`/print/admins/finance/tuition/${from}/${to}/${_class.id}`);*/}
                                    {/*}}>*/}
                                    {/*    <ThinPrintIcon/>*/}
                                    {/*    <span>پرینت</span>*/}
                                    {/*</button>*/}
                                    <button onClick={() => setSMSModal(true)}>
                                        <ThinnerSMSIcon/>
                                        <span>ارسال پیامک</span>
                                    </button>
                                </div>
                            </div>
                            <table className="table open-table table-striped table-bordered table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>دانش‌آموز</th>
                                    <th>کلاس</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((p, i) =>
                                        <tr key={"K39Ercn22Sx11QQ3S" + i}>
                                            <td style={{width: '10%'}}>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/students/view/${p.id}`}>
                                                    {p.name}
                                                </Link>
                                            </td>
                                            <td style={{width: '25%'}}>{StringDigitsConvertToPersian(p.class === '' ? '-' : p.class)}</td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AdminsSMSAbsentsModal
                active={smsModal}
                closeHandler={() => setSMSModal(false)}
                list={list}
            />
        </>
    );
};